import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
// @ts-ignore
import LogoImage from "../../assets/fav.png";

/* ─────────────────────────────────────────────
   GLOBAL STYLES
───────────────────────────────────────────── */
const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,800;0,9..144,900;1,9..144,800;1,9..144,900&family=Plus+Jakarta+Sans:wght@300;400;500;600&display=swap');
    *, *::before, *::after { box-sizing:border-box; margin:0; padding:0; }
    .zh { font-family:'Fraunces',Georgia,serif; }
    .zb { font-family:'Plus Jakarta Sans',sans-serif; }

    @keyframes slideR   { from{opacity:0;transform:translateX(-24px)} to{opacity:1;transform:translateX(0)} }
    @keyframes slideU   { from{opacity:0;transform:translateY(20px)}  to{opacity:1;transform:translateY(0)} }
    @keyframes cardInL  { from{opacity:0;transform:translateX(-28px) rotate(var(--r,0deg))} to{opacity:1;transform:translateX(0) rotate(var(--r,0deg))} }
    @keyframes cardInR  { from{opacity:0;transform:translateX(28px)  rotate(var(--r,0deg))} to{opacity:1;transform:translateX(0) rotate(var(--r,0deg))} }
    @keyframes cardSlide{ from{opacity:0;transform:translateX(22px)} to{opacity:1;transform:translateX(0)} }
    @keyframes ticker   { from{transform:translateX(0)} to{transform:translateX(-50%)} }
    @keyframes blink    { 0%,100%{opacity:1} 50%{opacity:.3} }
    @keyframes lineIn   { from{transform:scaleX(0);transform-origin:left} to{transform:scaleX(1);transform-origin:left} }
    @keyframes fadeNum  { from{opacity:0;transform:scale(.9)} to{opacity:.038;transform:scale(1)} }
    @keyframes barGrow  { from{width:0} to{width:var(--w)} }
    @keyframes menuOpen { from{opacity:0;transform:translateY(-8px)} to{opacity:1;transform:translateY(0)} }
    @keyframes countUp  { from{opacity:0;transform:translateY(6px)} to{opacity:1;transform:translateY(0)} }

    .a1{animation:slideR .65s cubic-bezier(.22,.68,0,1.2) both}
    .a2{animation:slideR .65s .1s cubic-bezier(.22,.68,0,1.2) both}
    .a3{animation:slideR .65s .2s cubic-bezier(.22,.68,0,1.2) both}
    .a4{animation:slideU .6s  .3s cubic-bezier(.22,.68,0,1.2) both}
    .a5{animation:slideU .6s  .4s cubic-bezier(.22,.68,0,1.2) both}
    .a6{animation:slideU .6s  .5s cubic-bezier(.22,.68,0,1.2) both}
    .a7{animation:slideU .6s  .6s cubic-bezier(.22,.68,0,1.2) both}
    .al{animation:lineIn .85s .25s both}

    .cl1{--r:-2.5deg; animation:cardInL .48s .60s both}
    .cl2{--r:-1.5deg; animation:cardInL .48s .85s both}
    .cl3{--r:-2deg;   animation:cardInL .48s 1.10s both}
    .cr1{--r: 2deg;   animation:cardInR .48s .72s both}
    .cr2{--r: 1.5deg; animation:cardInR .48s .97s both}
    .cr3{--r: 2.5deg; animation:cardInR .48s 1.22s both}

    .ms1{animation:cardSlide .4s .50s both}
    .ms2{animation:cardSlide .4s .62s both}
    .ms3{animation:cardSlide .4s .74s both}
    .ms4{animation:cardSlide .4s .86s both}
    .ms5{animation:cardSlide .4s .98s both}
    .ms6{animation:cardSlide .4s 1.10s both}

    .bar-anim{animation:barGrow .9s 1.7s cubic-bezier(.22,.68,0,1.2) both;width:0}
    .blink{animation:blink 1.6s ease-in-out infinite}
    .bgnum{animation:fadeNum .9s .15s both}
    .mob-menu-open{animation:menuOpen .22s both}

    .ticker-wrap{overflow:hidden;flex:1}
    .ticker-inner{display:flex;animation:ticker 36s linear infinite;width:max-content}
    .ticker-inner:hover{animation-play-state:paused}

    .btn-black{
      background:#111;color:#fff;border:none;cursor:pointer;
      font-family:'Plus Jakarta Sans',sans-serif;font-weight:600;
      position:relative;overflow:hidden;transition:transform .18s;
    }
    .btn-black::after{
      content:'';position:absolute;inset:0;background:#6cbb23;
      transform:translateY(102%);
      transition:transform .28s cubic-bezier(.22,.68,0,1.2);
    }
    .btn-black:hover{transform:translateY(-2px)}
    .btn-black:hover::after{transform:translateY(0)}
    .btn-black span{position:relative;z-index:1}
    .btn-black:active{transform:scale(.97)}

    .btn-line{
      background:transparent;border:1.5px solid #222;color:#222;cursor:pointer;
      font-family:'Plus Jakarta Sans',sans-serif;font-weight:500;
      transition:background .18s,color .18s,transform .18s;
      display:flex;align-items:center;justify-content:center;gap:8px;
    }
    .btn-line:hover{background:#222;color:#fff;transform:translateY(-2px)}
    .btn-line:active{transform:scale(.97)}

    .tag{
      display:inline-flex;align-items:center;gap:6px;
      border:1.5px solid #e0e0db;border-radius:999px;
      padding:5px 13px;font-size:12px;color:#777;
      background:#fff;transition:border-color .18s,color .18s;
      font-family:'Plus Jakarta Sans',sans-serif;
    }
    .tag:hover{border-color:#6cbb23;color:#3b6d11}

    .feature-tag{
      display:inline-flex;align-items:center;gap:6px;
      background:#f5f5f1;border:1.5px solid transparent;
      border-radius:10px;padding:7px 12px;
      font-size:12px;font-weight:500;color:#444;
      font-family:'Plus Jakarta Sans',sans-serif;
      transition:border-color .18s,background .18s,color .18s;
      cursor:default;white-space:nowrap;
    }
    .feature-tag:hover{border-color:#6cbb23;background:#f0fbe5;color:#3b6d11}

    .nav-ghost{
      background:none;border:none;cursor:pointer;
      font-family:'Plus Jakarta Sans',sans-serif;font-size:13px;
      color:#999;transition:color .18s;padding:4px 0;
    }
    .nav-ghost:hover{color:#111}

    .ocard{
      background:#fff;border-radius:14px;position:absolute;
      box-shadow:0 8px 28px rgba(0,0,0,.13),0 2px 5px rgba(0,0,0,.06);
    }
    .ocard-label{
      font-size:10px;font-weight:600;letter-spacing:.06em;
      text-transform:uppercase;font-family:'Plus Jakarta Sans',sans-serif;
    }
    .mini-bar-track{background:#f0f0ec;border-radius:4px;height:5px;overflow:hidden;flex:1}
    .mini-bar-fill{height:100%;border-radius:4px;background:#6cbb23}

    .cross::before,.cross::after{content:'';position:absolute;background:rgba(255,255,255,.2)}
    .cross::before{left:50%;top:0;bottom:0;width:1.5px;transform:translateX(-50%)}
    .cross::after{top:50%;left:0;right:0;height:1.5px;transform:translateY(-50%)}

    .mob-strip{
      display:flex;gap:10px;overflow-x:auto;
      padding:18px 16px;
      scroll-snap-type:x mandatory;
      -webkit-overflow-scrolling:touch;
      scrollbar-width:none;
    }
    .mob-strip::-webkit-scrollbar{display:none}
    .mob-card{
      background:#fff;border-radius:13px;flex-shrink:0;
      scroll-snap-align:start;
      box-shadow:0 5px 20px rgba(0,0,0,.11),0 1px 4px rgba(0,0,0,.06);
      padding:12px;
    }

    /* ── Mobile nav dropdown — anchors to fixed nav ── */
    .mob-nav-menu{
      position:fixed;
      /* top is set dynamically via inline style */
      left:0;right:0;
      background:#fff;border-bottom:1.5px solid #e6e6e0;
      padding:14px 20px;z-index:39;
      display:flex;flex-direction:column;gap:2px;
    }
    .mob-menu-btn{
      background:none;border:none;width:100%;text-align:left;
      padding:11px 8px;font-size:15px;color:#333;
      font-family:'Plus Jakarta Sans',sans-serif;cursor:pointer;
      border-bottom:1px solid #f0f0ec;transition:color .18s;
    }
    .mob-menu-btn:last-child{border-bottom:none}
    .mob-menu-btn:hover{color:#6cbb23}

    /* ── Fixed nav ── */
    .hero-nav{
      position:fixed; top:0; left:0; right:0;
      padding:18px 48px;
      display:flex; align-items:center; justify-content:space-between;
      border-bottom:1.5px solid #e6e6e0;
      background:#fafaf8;
      z-index:40;
      transition:background .25s, box-shadow .25s, border-color .25s;
    }
    .hero-nav.scrolled{
      background:rgba(250,250,248,.92);
      backdrop-filter:blur(16px);
      -webkit-backdrop-filter:blur(16px);
      box-shadow:0 2px 24px rgba(0,0,0,.08);
      border-bottom-color:#e0e0da;
    }

    .nav-links{ display:flex;align-items:center;gap:24px }
    .nav-hamburger{ display:none }

    .hero-split{ display:flex;flex:1 }
    .hero-left{
      flex:0 0 52%;padding:48px 40px 56px 60px;
      display:flex;flex-direction:column;justify-content:center;
      border-right:1.5px solid #e6e6e0;position:relative;overflow:hidden;
    }
    .hero-right{
      flex:1;position:relative;
      overflow:hidden;display:flex;align-items:center;justify-content:center;
      background: linear-gradient(
  135deg,
  #0c0f0c 0%,
  #0f1a0f 40%,
  #162b0f 70%,
  #0a0d0a 100%
);
    }
    .stats-grid{ display:grid;grid-template-columns:repeat(4,1fr) }
    .cta-row{ display:flex;flex-wrap:wrap;gap:12px }
    .cta-btn-primary{ padding:15px 32px }
    .cta-btn-secondary{ padding:15px 22px }

    /* Tablet */
    @media(max-width:1024px){
      .hero-nav{ padding:16px 28px }
      .hero-left{ flex:0 0 54%;padding:40px 28px 48px 36px }
    }

    /* Mobile */
    @media(max-width:768px){
      .hero-nav{ padding:14px 20px }
      .nav-links{ display:none }
      .nav-hamburger{ display:flex;align-items:center;gap:10px }
      .hero-split{ flex-direction:column }
      .hero-left{
        flex:none;width:100%;
        padding:28px 20px 32px;
        border-right:none;border-bottom:1.5px solid #e6e6e0;
      }
      .hero-right{ flex:none;width:100%;min-height:260px;height:auto }
      .stats-grid{ grid-template-columns:repeat(2,1fr);gap:14px 0 }
      .stats-grid > div{ padding-right:0 !important;border-right:none !important;margin-right:0 !important }
      .stats-grid > div:nth-child(odd){ border-right:1px solid #e6e6e0 !important;padding-right:12px !important;margin-right:12px !important }
      .cta-row{ flex-direction:column }
      .cta-btn-primary,.cta-btn-secondary{ width:100%;justify-content:center;padding:14px 20px }
      .feature-tags-wrap{ flex-wrap:nowrap !important;overflow-x:auto;padding-bottom:4px;scrollbar-width:none }
      .feature-tags-wrap::-webkit-scrollbar{ display:none }
      .hero-h1{ font-size:clamp(32px,8.5vw,46px) !important }
      .desktop-cards-wrap{ display:none !important }
      .mobile-strip-wrap{ display:block !important }
    }
    @media(min-width:769px){
      .mobile-strip-wrap{ display:none !important }
      .desktop-cards-wrap{ display:block !important }
    }
  `}</style>
);

/* ─────────────────────────────────────────────
   SHARED CARD ATOMS
───────────────────────────────────────────── */
const CardLabel = ({ children }: { children: React.ReactNode }) => (
  <span className="ocard-label" style={{ color: "#111" }}>{children}</span>
);

const Badge = ({ bg, color, children }: { bg: string; color: string; children: React.ReactNode }) => (
  <span style={{ fontSize: 10, background: bg, color, borderRadius: 20, padding: "2px 8px", fontFamily: "'Plus Jakarta Sans',sans-serif", fontWeight: 600 }}>
    {children}
  </span>
);

const MiniBarRow = ({ name, pct, val }: { name: string; pct: number; val: string }) => (
  <div style={{ marginBottom: 8 }}>
    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
      <span style={{ fontSize: 11, color: "#555", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>{name}</span>
      <span style={{ fontSize: 11, fontWeight: 600, color: "#6cbb23", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>{val}</span>
    </div>
    <div className="mini-bar-track">
      <div className="mini-bar-fill bar-anim" style={{ "--w": `${pct}%` } as React.CSSProperties} />
    </div>
  </div>
);

/* ─────────────────────────────────────────────
   DESKTOP CARDS
───────────────────────────────────────────── */
const DesktopCards = () => (
  <div className="desktop-cards-wrap" style={{ position: "relative", width: "100%", height: "100%", minHeight: 560 }}>
    <div className="zh bgnum" style={{
      position: "absolute", top: "50%", left: "50%",
      transform: "translate(-50%,-50%)",
      fontSize: 300, fontWeight: 900, color: "#fff", opacity: .04,
      lineHeight: 1, userSelect: "none", pointerEvents: "none"
    }}>₹</div>

    <div className="cross" style={{ position: "absolute", width: 18, height: 18, top: 24, left: "50%", transform: "translateX(-50%)" }} />
    <div className="cross" style={{ position: "absolute", width: 18, height: 18, bottom: 24, left: "50%", transform: "translateX(-50%)" }} />

    {/* L1 — New Order */}
    <div className="ocard cl1" style={{ top: 48, left: 34, width: 198, padding: "12px 14px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
        <CardLabel>New Order</CardLabel>
        <span style={{ fontSize: 9, color: "#bbb", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>09:41 AM</span>
      </div>
      <div style={{ fontSize: 12, color: "#555", lineHeight: 1.6, fontFamily: "'Plus Jakarta Sans',sans-serif" }}>
        Table 4 · Café Bliss
        <br /><span style={{ color: "#aaa", fontSize: 11 }}>1× Masala Chai ₹80</span>
        <br /><span style={{ color: "#aaa", fontSize: 11 }}>2× Paneer Tikka ₹320</span>
      </div>
      <div style={{ marginTop: 8, paddingTop: 8, borderTop: "1px solid #f0f0ec", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span className="zh" style={{ fontSize: 20, fontWeight: 900, color: "#111" }}>₹480</span>
        <Badge bg="#e8f5d4" color="#3b6d11">Confirmed ✓</Badge>
      </div>
    </div>

    {/* L2 — Salon Appointment */}
    <div className="ocard cl2" style={{ top: 280, left: 40, width: 206, padding: "12px 14px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 9 }}>
        <CardLabel>Appointment</CardLabel>
        <Badge bg="#ede9fe" color="#5b21b6">Confirmed</Badge>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 9 }}>
        <div style={{ width: 32, height: 32, borderRadius: "50%", background: "linear-gradient(135deg,#f9a8d4,#c084fc)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, flexShrink: 0, color: "#fff", fontWeight: 700, fontFamily: "'Plus Jakarta Sans',sans-serif" }}>P</div>
        <div>
          <div style={{ fontSize: 12, fontWeight: 600, color: "#111", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>Priya Sharma</div>
          <div style={{ fontSize: 10, color: "#aaa", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>Glamour Salon, Mumbai</div>
        </div>
      </div>
      <div style={{ background: "#fafaf8", borderRadius: 8, padding: "7px 9px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <div style={{ fontSize: 11, color: "#555", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>💇 Haircut + Highlights</div>
          <div style={{ fontSize: 10, color: "#aaa", fontFamily: "'Plus Jakarta Sans',sans-serif", marginTop: 1 }}>Today 2:30 PM</div>
        </div>
        <span className="zh" style={{ fontSize: 15, fontWeight: 800, color: "#111" }}>₹1,400</span>
      </div>
    </div>

    {/* L3 — GST Invoice */}
    <div className="ocard cl3" style={{ bottom: 64, left: 34, width: 200, padding: "12px 14px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 9 }}>
        <CardLabel>GST Invoice</CardLabel>
        <Badge bg="#fef9c3" color="#854d0e">#INV-1482</Badge>
      </div>
      <div style={{ fontSize: 22, fontWeight: 900, color: "#111", fontFamily: "'Fraunces',serif", lineHeight: 1, marginBottom: 8 }}>₹4,860</div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px 0", fontSize: 11, fontFamily: "'Plus Jakarta Sans',sans-serif" }}>
        {[
          { l: "CGST 9%", v: "₹389" }, { l: "SGST 9%", v: "₹389" },
          { l: "Subtotal", v: "₹4,082" }, { l: "Status", v: "Filed ✓" },
        ].map(({ l, v }) => (
          <React.Fragment key={l}>
            <span style={{ color: "#aaa" }}>{l}</span>
            <span style={{ color: "#444", fontWeight: 500, textAlign: "right" }}>{v}</span>
          </React.Fragment>
        ))}
      </div>
    </div>

    {/* R1 — Hot Items Analytics */}
    <div className="ocard cr1" style={{ top: 20, right: -110, width: 188, padding: "11px 13px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 5, marginBottom: 9 }}>
        <span style={{ fontSize: 13 }}>🔥</span>
        <CardLabel>Hot This Week</CardLabel>
      </div>
      <MiniBarRow name="Paneer Tikka" pct={88} val="142" />
      <MiniBarRow name="Masala Chai" pct={72} val="116" />
      <MiniBarRow name="Dal Makhani" pct={59} val="95" />
      <div style={{ marginTop: 4, fontSize: 10, color: "#bbb", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>Orders · last 7 days</div>
    </div>

    {/* R2 — Offer Campaign */}
    <div className="ocard cr2" style={{ top: 262, right: -110, width: 196, padding: "11px 13px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 5, marginBottom: 7 }}>
        <span style={{ fontSize: 13 }}>🎁</span>
        <CardLabel>Campaign Live</CardLabel>
        <span className="blink" style={{ marginLeft: "auto", width: 6, height: 6, borderRadius: "50%", background: "#f59e0b", display: "inline-block" }} />
      </div>
      <div style={{ fontSize: 11, color: "#555", fontFamily: "'Plus Jakarta Sans',sans-serif", marginBottom: 9, lineHeight: 1.45 }}>
        "Weekend Special — 20% off all combos 🍽️"
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 5 }}>
        {[{ l: "Sent", val: "312" }, { l: "Opened", val: "248" }, { l: "Redeemed", val: "67" }, { l: "Rev ↑", val: "₹8.4K" }].map(({ l, val }) => (
          <div key={l} style={{ background: "#f8f8f5", borderRadius: 7, padding: "5px 7px" }}>
            <div style={{ fontSize: 9, color: "#bbb", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>{l}</div>
            <div className="zh" style={{ fontSize: 14, fontWeight: 800, color: "#111" }}>{val}</div>
          </div>
        ))}
      </div>
    </div>

    {/* R3 — Loyal Customer */}
    <div className="ocard cr3" style={{ bottom: 64, right: -120, width: 192, padding: "11px 13px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 5, marginBottom: 9 }}>
        <span style={{ fontSize: 13 }}>⭐</span>
        <CardLabel>Loyal Customer</CardLabel>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 9 }}>
        <div style={{ width: 34, height: 34, borderRadius: "50%", background: "linear-gradient(135deg,#fde68a,#f59e0b)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, flexShrink: 0, color: "#92400e", fontWeight: 700, fontFamily: "'Plus Jakarta Sans',sans-serif" }}>R</div>
        <div>
          <div style={{ fontSize: 12, fontWeight: 600, color: "#111", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>Rahul is back! 👋</div>
          <div style={{ fontSize: 10, color: "#aaa", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>4th visit this month</div>
        </div>
      </div>
      <div style={{ background: "#fffbeb", borderRadius: 8, padding: "6px 9px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ fontSize: 11, color: "#78350f", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>Lifetime spend</span>
        <span className="zh" style={{ fontSize: 15, fontWeight: 900, color: "#92400e" }}>₹6,240</span>
      </div>
      <div style={{ marginTop: 7, fontSize: 10, color: "#bbb", fontFamily: "'Plus Jakarta Sans',sans-serif", display: "flex", alignItems: "center", gap: 4 }}>
        <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#6cbb23", display: "inline-block" }} />
        Auto-offer sent via WhatsApp
      </div>
    </div>
  </div>
);

/* ─────────────────────────────────────────────
   MOBILE CARD STRIP
───────────────────────────────────────────── */
const MobileCardStrip = () => (
  <div className="mobile-strip-wrap" style={{ width: "100%" }}>
    <div className="mob-strip">
      <div className="mob-card ms1" style={{ width: 186 }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 7 }}>
          <span style={{ fontSize: 9, fontWeight: 700, color: "#111", letterSpacing: ".06em", textTransform: "uppercase", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>New Order</span>
          <span style={{ fontSize: 9, color: "#bbb", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>Table 4</span>
        </div>
        <div style={{ fontSize: 11, color: "#666", fontFamily: "'Plus Jakarta Sans',sans-serif", lineHeight: 1.5, marginBottom: 7 }}>Masala Chai · Paneer Tikka</div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span className="zh" style={{ fontSize: 19, fontWeight: 900, color: "#111" }}>₹480</span>
          <span style={{ fontSize: 9, background: "#e8f5d4", color: "#3b6d11", borderRadius: 20, padding: "2px 7px", fontFamily: "'Plus Jakarta Sans',sans-serif", fontWeight: 600 }}>✓ Done</span>
        </div>
      </div>

      <div className="mob-card ms2" style={{ width: 176 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 9 }}>
          <span style={{ fontSize: 12 }}>🔥</span>
          <span style={{ fontSize: 9, fontWeight: 700, color: "#111", letterSpacing: ".06em", textTransform: "uppercase", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>Top Items</span>
        </div>
        {[{ n: "Paneer Tikka", v: 88 }, { n: "Masala Chai", v: 72 }, { n: "Dal Makhani", v: 59 }].map(({ n, v }) => (
          <div key={n} style={{ marginBottom: 6 }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
              <span style={{ fontSize: 10, color: "#555", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>{n}</span>
              <span style={{ fontSize: 10, color: "#6cbb23", fontFamily: "'Plus Jakarta Sans',sans-serif", fontWeight: 600 }}>{v}%</span>
            </div>
            <div className="mini-bar-track">
              <div className="mini-bar-fill bar-anim" style={{ "--w": `${v}%` } as React.CSSProperties} />
            </div>
          </div>
        ))}
      </div>

      <div className="mob-card ms3" style={{ width: 186 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 9 }}>
          <span style={{ fontSize: 9, fontWeight: 700, color: "#111", letterSpacing: ".06em", textTransform: "uppercase", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>Appointment</span>
          <span style={{ fontSize: 9, background: "#ede9fe", color: "#5b21b6", borderRadius: 20, padding: "2px 7px", fontFamily: "'Plus Jakarta Sans',sans-serif", fontWeight: 600 }}>✓</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 7 }}>
          <div style={{ width: 28, height: 28, borderRadius: "50%", background: "linear-gradient(135deg,#f9a8d4,#c084fc)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, flexShrink: 0, color: "#fff", fontWeight: 700, fontFamily: "'Plus Jakarta Sans',sans-serif" }}>P</div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, color: "#111", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>Priya Sharma</div>
            <div style={{ fontSize: 9, color: "#aaa", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>💇 Haircut + Highlights</div>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontSize: 10, color: "#aaa", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>Today 2:30 PM</span>
          <span className="zh" style={{ fontSize: 15, fontWeight: 800, color: "#111" }}>₹1,400</span>
        </div>
      </div>

      <div className="mob-card ms4" style={{ width: 182 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 7 }}>
          <span style={{ fontSize: 9, fontWeight: 700, color: "#111", letterSpacing: ".06em", textTransform: "uppercase", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>GST Invoice</span>
          <span style={{ fontSize: 9, background: "#fef9c3", color: "#854d0e", borderRadius: 20, padding: "2px 7px", fontFamily: "'Plus Jakarta Sans',sans-serif", fontWeight: 600 }}>Filed ✓</span>
        </div>
        <div className="zh" style={{ fontSize: 22, fontWeight: 900, color: "#111", lineHeight: 1, marginBottom: 8 }}>₹4,860</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "3px 0", fontSize: 10, fontFamily: "'Plus Jakarta Sans',sans-serif" }}>
          {[{ l: "CGST 9%", v: "₹389" }, { l: "SGST 9%", v: "₹389" }].map(({ l, v }) => (
            <React.Fragment key={l}>
              <span style={{ color: "#aaa" }}>{l}</span>
              <span style={{ color: "#444", fontWeight: 500, textAlign: "right" }}>{v}</span>
            </React.Fragment>
          ))}
        </div>
      </div>

      <div className="mob-card ms5" style={{ width: 186 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 7 }}>
          <span style={{ fontSize: 12 }}>🎁</span>
          <span style={{ fontSize: 9, fontWeight: 700, color: "#111", letterSpacing: ".06em", textTransform: "uppercase", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>Campaign</span>
          <span className="blink" style={{ marginLeft: "auto", width: 5, height: 5, borderRadius: "50%", background: "#f59e0b", display: "inline-block" }} />
        </div>
        <div style={{ fontSize: 10, color: "#555", fontFamily: "'Plus Jakarta Sans',sans-serif", marginBottom: 8, lineHeight: 1.45 }}>Weekend Special — 20% off combos</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 4 }}>
          {[{ l: "Sent", v: "312" }, { l: "Opened", v: "248" }, { l: "Redeemed", v: "67" }, { l: "Revenue", v: "₹8.4K" }].map(({ l, v }) => (
            <div key={l} style={{ background: "#f8f8f5", borderRadius: 6, padding: "4px 6px" }}>
              <div style={{ fontSize: 8, color: "#bbb", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>{l}</div>
              <div className="zh" style={{ fontSize: 13, fontWeight: 800, color: "#111" }}>{v}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="mob-card ms6" style={{ width: 182 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 8 }}>
          <span style={{ fontSize: 12 }}>⭐</span>
          <span style={{ fontSize: 9, fontWeight: 700, color: "#111", letterSpacing: ".06em", textTransform: "uppercase", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>Loyal Customer</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 8 }}>
          <div style={{ width: 28, height: 28, borderRadius: "50%", background: "linear-gradient(135deg,#fde68a,#f59e0b)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, flexShrink: 0, color: "#92400e", fontWeight: 700, fontFamily: "'Plus Jakarta Sans',sans-serif" }}>R</div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 600, color: "#111", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>Rahul is back! 👋</div>
            <div style={{ fontSize: 9, color: "#aaa", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>4th visit this month</div>
          </div>
        </div>
        <div style={{ background: "#fffbeb", borderRadius: 7, padding: "5px 8px", display: "flex", justifyContent: "space-between" }}>
          <span style={{ fontSize: 10, color: "#78350f", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>Lifetime spend</span>
          <span className="zh" style={{ fontSize: 14, fontWeight: 900, color: "#92400e" }}>₹6,240</span>
        </div>
      </div>

      <div style={{ flexShrink: 0, width: 6 }} />
    </div>

    <div style={{ display: "flex", justifyContent: "center", gap: 5, paddingBottom: 14 }}>
      {[0, 1, 2, 3, 4, 5].map(i => (
        <div key={i} style={{ width: i === 0 ? 16 : 5, height: 5, borderRadius: 3, background: i === 0 ? "#fff" : "rgba(255,255,255,.3)", transition: "width .3s" }} />
      ))}
    </div>
  </div>
);

/* ─────────────────────────────────────────────
   TICKER
───────────────────────────────────────────── */
const Ticker = () => {
  const items = [
    "🍽️ Table 3 · Hotel Raj — Order ₹1,240",
    "💇 Appointment · Glamour Salon — Priya, 2:30 PM",
    "🎁 Offer redeemed · Café Bliss — 12 customers",
    "🧾 GST Invoice #1482 · ₹4,860 filed",
    "🍕 Table 5 · Pizzeria Milano — ₹740",
    "⭐ Rahul back for 4th visit · Spice Garden",
    "💆 Spa Booking · Serenity Spa — Anjali, 4:00 PM",
    "📊 Analytics — Paneer Tikka top seller this week",
    "🎁 Campaign sent to 248 customers · ₹8.4K rev",
  ];
  return (
    <div style={{ borderTop: "1.5px solid #e6e6e0", background: "#fafaf8", display: "flex", alignItems: "center", height: 44, overflow: "hidden" }}>
      <div style={{
        flexShrink: 0, padding: "0 14px", borderRight: "1.5px solid #e6e6e0",
        fontSize: 10, fontWeight: 600, letterSpacing: ".1em", textTransform: "uppercase",
        color: "#6cbb23", fontFamily: "'Plus Jakarta Sans',sans-serif",
        height: "100%", display: "flex", alignItems: "center", whiteSpace: "nowrap"
      }}>Live</div>
      <div className="ticker-wrap">
        <div className="ticker-inner">
          {[...items, ...items].map((item, i) => (
            <span key={i} style={{ fontFamily: "'Plus Jakarta Sans',sans-serif", fontSize: 12, color: "#888", padding: "0 24px", borderRight: "1px solid #ebebeb", whiteSpace: "nowrap" }}>
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────────
   NAV HEIGHT CONSTANT
   Keep in sync with .hero-nav padding + logo height.
   Desktop: 18px top + 18px bottom + 34px logo ≈ 70px
   Mobile:  14px top + 14px bottom + 34px logo ≈ 62px
───────────────────────────────────────────── */
const NAV_H_DESKTOP = 70;
const NAV_H_MOBILE = 62;

/* ─────────────────────────────────────────────
   MAIN HERO
───────────────────────────────────────────── */
const NewHero2 = () => {
  const navigate = useNavigate();
  const currentRole = localStorage.getItem("role");
  const hasEmail = localStorage.getItem("user");

  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [navH, setNavH] = useState(NAV_H_DESKTOP);

  /* Scroll listener — toggles frosted glass effect */
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* Nav height tracker — keeps paddingTop accurate across breakpoints */
  useEffect(() => {
    const measure = () => {
      const nav = document.getElementById("zafflo-nav");
      if (nav) setNavH(nav.offsetHeight);
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  /* Close menu on outside click */
  useEffect(() => {
    if (!menuOpen) return;
    const h = () => setMenuOpen(false);
    document.addEventListener("click", h);
    return () => document.removeEventListener("click", h);
  }, [menuOpen]);

  const goToDash = () => {
    setMenuOpen(false);
    if (currentRole && hasEmail) {
      navigate(currentRole === "admin" ? "/admin" : currentRole === "employee" ? "/employee" : "/user");
      return;
    }
    navigate("/login");
  };

  const verticals = ["Restaurant", "Café", "Salon", "Hotel", "Spa", "Food Stall"];
  const [vIdx, setVIdx] = useState(0);
  const [vVisible, setVVisible] = useState(true);
  useEffect(() => {
    const id = setInterval(() => {
      setVVisible(false);
      setTimeout(() => { setVIdx(i => (i + 1) % verticals.length); setVVisible(true); }, 280);
    }, 2200);
    return () => clearInterval(id);
  }, []);

  const features = [
    { icon: "🛒", label: "WhatsApp Ordering" },
    { icon: "🔥", label: "Sales Analytics" },
    { icon: "🧾", label: "GST Billing" },
    { icon: "📅", label: "Appointments" },
    { icon: "🎁", label: "Customer Offers" },
    { icon: "🌏", label: "12+ Languages" },
  ];

  return (
    <>
      <GlobalStyles />

      {/*
        paddingTop = measured nav height so content
        never hides behind the fixed bar.
      */}
      <div className="zb" style={{ background: "#fafaf8", minHeight: "100vh", display: "flex", flexDirection: "column", paddingTop: navH }}>

        {/* ── FIXED NAV ── */}
        <nav
          id="zafflo-nav"
          className={`hero-nav${scrolled ? " scrolled" : ""}`}
        >
          <img src={LogoImage} alt="Zafflo" style={{ height: 34, width: "auto" }} />


          {/* Desktop links */}
          <div className="nav-links">
            <button
              className="nav-ghost"
              onClick={() => navigate("/free-online-qr-menu-generator")}
            >
              Try Our FREE QR Generator
            </button>
            <button className="nav-ghost" onClick={() => document.getElementById("BookDemo")?.scrollIntoView({ behavior: "smooth" })}>
              Book Demo
            </button>
            <button className="nav-ghost" onClick={() => document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth" })} style={{ color: "#555" }}>
              Pricing
            </button>
            <button
              onClick={goToDash}
              style={{ padding: "9px 20px", borderRadius: 8, fontSize: 13, fontWeight: 600, background: "#111", color: "#fff", border: "none", cursor: "pointer", fontFamily: "'Plus Jakarta Sans',sans-serif", transition: "background .18s" }}
              onMouseOver={e => (e.currentTarget.style.background = "#6cbb23")}
              onMouseOut={e => (e.currentTarget.style.background = "#111")}
            >
              {currentRole ? "Dashboard →" : "Sign In →"}
            </button>
          </div>

          {/* Mobile: Sign In + hamburger */}
          <div className="nav-hamburger" style={{ gap: 10 }}>
            <button
              onClick={goToDash}
              style={{ padding: "8px 14px", borderRadius: 8, fontSize: 13, fontWeight: 600, background: "#111", color: "#fff", border: "none", cursor: "pointer", fontFamily: "'Plus Jakarta Sans',sans-serif" }}
            >
              {currentRole ? "Dashboard" : "Sign In"}
            </button>
            <button
              onClick={e => { e.stopPropagation(); setMenuOpen(o => !o); }}
              style={{ background: "none", border: "none", cursor: "pointer", padding: 4, display: "flex", flexDirection: "column", gap: 5 }}
              aria-label="Menu"
            >
              {[0, 1, 2].map(i => (
                <span key={i} style={{
                  display: "block", width: 22, height: 2, background: "#333", borderRadius: 2, transition: "all .22s",
                  transform: menuOpen
                    ? (i === 0 ? "rotate(45deg) translate(5px,5px)"
                      : i === 2 ? "rotate(-45deg) translate(5px,-5px)"
                        : "scaleX(0)")
                    : "none",
                  opacity: menuOpen && i === 1 ? 0 : 1,
                }} />
              ))}
            </button>
          </div>

          {/* Mobile dropdown — fixed, positioned just below nav */}
          {menuOpen && (
            <div
              className="mob-nav-menu mob-menu-open"
              style={{ top: navH }}
              onClick={e => e.stopPropagation()}
            >
              <button
                className="mob-menu-btn"
                onClick={() => navigate("/free-online-qr-menu-generator")}
              >
                Try Our FREE QR Generator
              </button>
              <button className="mob-menu-btn" onClick={() => { document.getElementById("BookDemo")?.scrollIntoView({ behavior: "smooth" }); setMenuOpen(false); }}>
                Book Demo
              </button>
              <button className="mob-menu-btn" onClick={() => { document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth" }); setMenuOpen(false); }}>
                Pricing
              </button>
              <button
                className="mob-menu-btn"
                style={{ color: "#6cbb23", fontWeight: 600 }}
                onClick={() => { navigate("/signup"); setMenuOpen(false); }}
              >
                Start Free Trial →
              </button>
            </div>
          )}
        </nav>

        {/* ── SPLIT ── */}
        <div className="hero-split">

          {/* LEFT */}
          <div className="hero-left">
            <div className="zh bgnum" style={{ position: "absolute", right: -32, bottom: -50, fontSize: 420, fontWeight: 900, color: "#6cbb23", opacity: .026, lineHeight: 1, userSelect: "none", pointerEvents: "none" }}>Z</div>

            <div className="a1" style={{ marginBottom: 22 }}>
              <span className="tag">
                <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#6cbb23", display: "inline-block" }} />
                <span>For every&nbsp;</span>
                <span style={{ display: "inline-block", fontWeight: 600, color: "#3b6d11", transition: "opacity .28s, transform .28s", opacity: vVisible ? 1 : 0, transform: vVisible ? "translateY(0)" : "translateY(-5px)" }}>
                  {verticals[vIdx]}
                </span>
                &nbsp;in India 🇮🇳
              </span>
            </div>

            <h1 className="zh a2 hero-h1" style={{ fontSize: "clamp(36px,4.4vw,60px)", fontWeight: 900, lineHeight: 1.07, letterSpacing: "-0.03em", color: "#111", fontStyle: "italic" }}>
              One QR Code.<br />
              Your Entire Business<br />
              on{" "}
              <mark style={{ background: "#6cbb23", color: "#fff", padding: "2px 14px 6px", borderRadius: 6, fontStyle: "italic", display: "inline-block" }}>
                Digital Platform
              </mark>
            </h1>

            <div className="al" style={{ height: "1.5px", background: "#e6e6e0", margin: "22px 0" }} />

            <p className="a4" style={{ fontSize: 15, lineHeight: 1.75, color: "#888", maxWidth: 440, fontWeight: 300 }}>
              Orders, salon bookings, hot-item analytics, GST-ready invoices, and
              repeat-customer offers — all from one dashboard, delivered to WhatsApp.
            </p>

            <div className="a5 feature-tags-wrap" style={{ marginTop: 20, display: "flex", flexWrap: "wrap", gap: 8 }}>
              {features.map(({ icon, label }) => (
                <span key={label} className="feature-tag">
                  <span style={{ fontSize: 13 }}>{icon}</span>
                  {label}
                </span>
              ))}
            </div>

            <div className="a6 cta-row" style={{ marginTop: 28 }}>
              <button className="btn-black cta-btn-primary" onClick={() => navigate("/signup")} style={{ borderRadius: 10, fontSize: 15 }}>
                <span>Start Free — No Card Needed</span>
              </button>
              <button className="btn-line cta-btn-secondary" onClick={() => document.getElementById("BookDemo")?.scrollIntoView({ behavior: "smooth" })} style={{ borderRadius: 10, fontSize: 15 }}>
                <FaWhatsapp color="#6cbb23" size={16} />
                See Live Demo
              </button>
            </div>

            <div className="a7 stats-grid" style={{ marginTop: 36, paddingTop: 24, borderTop: "1.5px solid #e6e6e0" }}>
              {[
                { v: "2 min", l: "Setup time", accent: false },
                { v: "ZERO", l: "App downloads", accent: false },
                { v: "GST ✓", l: "Ready billing", accent: true },
                { v: "12+", l: "Indian languages", accent: false },
              ].map(({ v, l, accent }, i) => (
                <div key={l} style={{ paddingRight: i < 3 ? 12 : 0, borderRight: i < 3 ? "1px solid #e6e6e0" : "none", marginRight: i < 3 ? 12 : 0 }}>
                  <div className="zh" style={{ fontSize: 24, fontWeight: 900, color: accent ? "#6cbb23" : "#111", lineHeight: 1 }}>{v}</div>
                  <div style={{ fontSize: 10, color: "#bbb", marginTop: 4, letterSpacing: ".02em" }}>{l}</div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT */}
          <div className="hero-right">
            <div style={{ position: "absolute", inset: 0, backgroundImage: "linear-gradient(rgba(255,255,255,.07) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.07) 1px,transparent 1px)", backgroundSize: "48px 48px", zIndex: 0 }} />
            <div style={{ position: "absolute", top: 16, right: 18, zIndex: 3, fontSize: 10, color: "rgba(255,255,255,.55)", fontFamily: "'Plus Jakarta Sans',sans-serif", letterSpacing: ".1em", textTransform: "uppercase" }}>
              Dashboard Preview
            </div>
            <div style={{ position: "absolute", bottom: 14, left: 18, zIndex: 3, fontSize: 11, color: "rgba(255,255,255,.4)", fontFamily: "'Plus Jakarta Sans',sans-serif" }}>
              Orders · Analytics · GST · Bookings · Offers · Loyalty
            </div>
            <div style={{ position: "relative", zIndex: 2, width: "100%", height: "100%", maxWidth: 500 }}>
              <DesktopCards />
            </div>
            <div style={{ position: "relative", zIndex: 2, width: "100%" }}>
              <MobileCardStrip />
            </div>
          </div>
        </div>

        <Ticker />
      </div>
    </>
  );
};

export default NewHero2;